jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 1350,
    spans: 'hide',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });
  $('.nav-toggle').click(function (e) {
    openMenu();
    //Hit Escape, close menu
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        closeMenu();
      }
    });
    //Click outside of open menu, close menu
    $(document).on('click', function (event) {
      if (!$(event.target).closest("header").length) {
        closeMenu();
      }
    });
  });

  $('.nav-toggle').keypress(function (e) {
    openMenu();
    //Hit Escape, close menu
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        closeMenu();
      }
    });
    //Click outside of open menu, close menu
    $(document).on('click', function (event) {
      if (!$(event.target).closest("header").length) {
        closeMenu();
      }
    });
  });

  //Tab to nav-toggle after last link in nav menu to trap focus
  $('.nav-primary a:last').on('focusout', function (event) {
    var $target = $(event.target);
    if (!$target.closest('.nav-items').length) {
      $('.nav-toggle').focus();
    }
  });

  function openMenu() {
    $('body').toggleClass('open');
    $('body').attr('data-attr', 'no-scroll');
    $('.nav-toggle').toggleClass('move');
    $('.nav-primary .ul1 li').first().focus();
    // $('span.toggler.open').removeClass('open');
  }

  function closeMenu() {
    $('body').removeClass('open');
    $('body').removeAttr('data-attr');
    $('.nav-toggle').removeClass('move');
    // $('.nav-toggle').first().focus();
    // $('span.toggler.open').removeClass('open');
  }
  //Nav Functionality - End

  //Add in ul titles for mobile menu
  $('.mobile-menu .ul2, .mobile-menu .ul3, .mobile-menu .ul4').each(function () {
    title = $(this).prevAll('a').text();
    link = $(this).prevAll('a').attr('href');
    $(this).prepend('<li class="title"><a>' + title + '</a> <span class="toggler open" tabindex="-1"></span></li>');
  });
  $('.mobile-menu .ul2 > li.title span.toggler.open').on('click', function () {
    $('.mobile-menu .ul2, .mobile-menu .ul1 li').removeClass('open');
  });
  $('.mobile-menu .ul3 > li.title span.toggler.open').on('click', function () {
    $('.mobile-menu .ul3.open').removeClass('open');
  });
  $('.mobile-menu .ul4 > li.title span.toggler.open').on('click', function () {
    $('.mobile-menu .ul4.open').removeClass('open');
  });
  $('.mobile-menu .ul2 > li span.toggler.open').on('keypress', function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      e.preventDefault();
      $('.mobile-menu .ul2, .mobile-menu .ul1 li').removeClass('open');
    }
  });
  $('.mobile-menu .ul3 > li span.toggler.open').on('keypress', function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      e.preventDefault();
      $('.mobile-menu .ul3, .mobile-menu .ul1 li').removeClass('open');
    }
  });
  $('.mobile-menu .ul4 > li span.toggler.open').on('keypress', function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      e.preventDefault();
      $('.mobile-menu .ul4, .mobile-menu .ul1 li').removeClass('open');
    }
  });

  //Nav Placeholder functionality
  $('.mobile-menu ul li a:not([href]), .mobile-menu ul li a[href=""]').click(function () {
    $(this).closest('li').toggleClass('open');
    $(this).parent().find('>ul').toggleClass('open');
  });

  $('.mobile-menu ul li a:not([href])').on('keypress', function (e) {
    if (e.which === 13) {
      $(this).closest('li').toggleClass('open');
      $(this).parent().find('>ul').toggleClass('open');
    }
  });
  //Nav Placeholder functionality end

  // search
  $('.search-form > button').click(function (e) {
    e.preventDefault();
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $('.search-form input[type="search"]').val();
    var url = root + terms;
    // console.log(url);
    window.location.href = url;
  });
  $('.search-form input[type="search"]').on('keyup', function (e) {
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $(this).val();
    var url = root + terms;
    // console.log(url);
    if (e.which === 13) {
      window.location.href = url;
    }
  });
  $(".search-form input[type='search']").focusin(function () {
    $('.search-form').addClass('active');
  });
  $(".search-form input[type='search']").focusout(function () {
    $('.search-form').removeClass('active');
  });

  //Search Functionality - Start
  $('.search-toggle').click(function () {
    $('.search-box.desktop').toggle();
  });

  $('.search-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      $('.search-box').toggle();
      $('.search-toggle .fa-search').toggle();
      $('.search-toggle .fa-times').toggle();
    }
  });
  //Nav Functionality - END



  //Mega menu functionality
  //On hover
  //$('.nav-primary .ul1 .li1 .a1').mouseenter(function () {
  //  $('.nav-primary .ul1 .li1.active').removeClass('active');
  //  $(this).parent().addClass('active');
  //  $('.li1.active > .a1').focus();
  //  $('.nav-primary .ul1 .li1.active').mouseleave(function () {
  //    $(this).removeClass('active');
  //    $('.nav-primary .ul1 .a1').blur();
  //  });
  //});

  //On click
  // $('.nav-primary .ul1 .li1 a').on('click', function () {
  //   $(this).parent().toggleClass('active').siblings().removeClass('active');
  //   $(document).on('click', function (event) {
  //     if (!$(event.target).closest(".desktop-menu").length) {
  //       $('.li1.active').removeClass('active');
  //     }
  //   });
  //   $('.desktop-menu .li1.active .ul2 li a:last').focusout(function () {
  //     $('.desktop-menu .li1.active').removeClass('active');
  //   });
  //   //Close menu on escape
  //   $(document).on('keyup', function (e) {
  //     if (e.keyCode === 27) {
  //       $('.li1.active').removeClass('active');
  //     }
  //   });
  // });

  //On Enter
  $('.nav-primary .ul1 .li1 a').keypress(function (e) {
    $('.li1.active').not(this).removeClass('active');
    $(this).closest('.li1').toggleClass('active');
    $(document).on('click', function (event) {
      if (!$(event.target).closest(".desktop-menu").length) {
        $('.li1.active').removeClass('active');
      }
    });
    $('.desktop-menu .li1.active .ul2 li a:last').focusout(function () {
      $('.desktop-menu .li1.active').removeClass('active');
    });
    //Close menu on escape
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        $('.li1.active').removeClass('active');
      }
    });
  });
  //Mega menu functionality

  //Desktop Nav Menu
  if ($(".desktop-menu .heading").length) {
    $(".desktop-menu .heading").parent().addClass('menu-content');
    $(".desktop-menu .menu-content img").each(function () {
      $(this).unwrap('p');
      $(this).prependTo($(this).parent());
    });
  }

  //Slide to sections on click
  $('main a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('.open-modal')
    .not('[role="tab"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 2000, function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });


  //Open external links in new window
  $('a').filter('[href^="http"], [href^="//"]').not('[href*="' + window.location.host + '"]').attr('target', '_blank');
  $('a[href$=".pdf"]').prop('target', '_blank');

  //Scroll to Top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
      $(".scroll-to-top").css("opacity", "1");
    } else {
      $(".scroll-to-top").css("opacity", "0");
    }
  });
  $(".scroll-to-top").click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });

  //Sticky Alert
  var stick = $('.alerts').offset().top;
  $(window).scroll(function () {
    if ($(window).scrollTop() >= stick) {
      $('.alerts').css({
        position: 'fixed',
        top: '0',
        left: '0'

      });
    }
    if ($(this).scrollTop() <= 0) {
      $('.alerts').css({
        position: 'relative'
      });
    }

    if ($(window).width() < 768) {
      $('.alerts').css({
        position: 'relative'
      });
    }


  });

  $('a.open-modal[href="#newsletter"]').click(function () {
    $('#newsletter .modal-content iframe[data-src]').attr('src', $('#newsletter .modal-content iframe[data-src]').attr('data-src'));
  });

  $('a.open-modal[href="#download"]').click(function () {
    $('#download .modal-content iframe[data-src]').attr('src', $('#download .modal-content iframe[data-src]').attr('data-src'));
  });



});